import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import { editClient } from "../api/editClient";
import type { ClientData } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useEditClient = (): UseMutationResult<ApiResponse, ApiError, ClientData> => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: editClient,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: withPrefix(['clients']) });
        }
    })
}
